import script from "./SaemitalkIntroduction.vue?vue&type=script&setup=true&lang=ts"
export * from "./SaemitalkIntroduction.vue?vue&type=script&setup=true&lang=ts"

import "./SaemitalkIntroduction.vue?vue&type=style&index=0&id=99c146ea&lang=css"

const __exports__ = script;

export default __exports__